<template>
    <div class="fail">
        <div class="fail-header">
        </div>

        <div class="fail-content">
            <p>An error has occurred. This could be for any of the following reasons:</p>
            <div class="space-20"></div>
            <ul>
                <li>Mismatching IPs</li>
                <p>You must link your account from the same IP you are connected with in-game</p>
                <li>Invalid link ID</li>
                <li>Invalid forums email</li>
            </ul>
            <div class="space-20"></div>
            <p>Please create a support ticket so we can assist you further</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "fail"
    }
</script>